import { render, staticRenderFns } from "./ResourceGraphs.vue?vue&type=template&id=4b5ceae8&scoped=true&"
import script from "./ResourceGraphs.vue?vue&type=script&lang=js&"
export * from "./ResourceGraphs.vue?vue&type=script&lang=js&"
import style0 from "./ResourceGraphs.vue?vue&type=style&index=0&id=4b5ceae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ceae8",
  null
  
)

export default component.exports